var _g, _g2, _path, _g3, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 200 200",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.03922,0,0,1.03922,-3.67945,-4.92157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.376,149.233C50.487,149.096 51.36,148.217 51.489,147.106C52.536,138.095 56.962,100 56.962,100C36.777,111.335 30.399,129.536 35,151C35,151 45.088,149.76 49.376,149.233Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.03922,0,0,1.03922,203.412,-4.92157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.396,163.028L60.811,98.075C38.701,108.449 27.89,129.047 35,151C37.78,159.586 52.999,163.22 66.396,163.028Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76,100C76,100 91.049,135.114 95.668,145.892C96.008,146.685 96.668,147.296 97.485,147.573C98.301,147.85 99.197,147.768 99.949,147.346C102.574,145.873 106,143.951 106,143.951L124,100C112,111.293 88,110.7 76,100Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04054,0,0,1.04054,-14.4595,1.47297)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 50,
    r: 37
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.147,143.951L109.451,143.951C120.793,143.951 130,153.159 130,164.5C130,175.841 120.793,185.049 109.451,185.049L55.549,185.049C44.207,185.049 35,175.841 35,164.5C35,157.36 38.65,151.065 44.184,147.382"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatient);
export default __webpack_public_path__ + "static/media/patient.694cc905.svg";
export { ForwardRef as ReactComponent };